import React from "react";
import Routes from "./Routes";
import useGoogleAnalytics from "./hooks/useGoogleAnalytics";

function App() {
  useGoogleAnalytics();
  
  return (
    <Routes />
  );
}

export default App;
